import { contentTypeToKind } from '../types';
import { kindLabel } from './display';

type BadgeVariant = 'default' | 'secondary' | 'destructive' | 'outline';

// List-row display helpers (doc 09 §4.1). Port of the ModerationScreen.kt row renderer for the fields
// the admin-api ItemResponseDTO actually exposes (id/contentType/fileType/thumbnail/reportType/
// reportStatus/createdAt). Name/handle/content/reportedBy are NOT in the 7-field DTO — see columns.tsx.

/** contentType code -> a human "Type" label via the shared kind mapping. */
export function itemTypeLabel(contentType: string | null | undefined): string {
  // Live reports are still CONTENT for actions/detail, but list Type should say Live.
  if ((contentType ?? '').trim().toUpperCase() === 'L') return 'Live';
  return kindLabel(contentTypeToKind(contentType));
}

export interface ReportStatusDisplay {
  label: string;
  variant: BadgeVariant;
}

/** PENDING -> Pending (secondary), COMPLETED -> Completed (default), else raw/Unknown. */
export function reportStatusDisplay(status: string | null | undefined): ReportStatusDisplay {
  switch ((status ?? '').trim().toUpperCase()) {
    case 'PENDING':
      return { label: 'Pending', variant: 'secondary' };
    case 'COMPLETED':
      return { label: 'Completed', variant: 'default' };
    default:
      return { label: status || 'Unknown', variant: 'outline' };
  }
}
